// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconHamburger = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 6a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 12a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1zM2 18a1 1 0 011-1h18a1 1 0 110 2H3a1 1 0 01-1-1z"
      fill="currentColor"
    />
  );
export default SvgIconHamburger;
